import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import {
  Box,
  Chip,
  Table,
  Paper,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Typography,
  TableContainer,
} from "@mui/material";

import Title from "../../../common/Title";
import ApiLogHistory from "../../../common/ApiLogHistory";

import useAxios from "../../../../hooks/useAxios";
import { __getPortoutLog } from "../../../../api/sim";
import { getChipColor } from "../../../../constants/value";

const PortoutHistory = (props) => {
  const [portoutHistory, setPortoutHistory] = useState([]);
  const { portout_id } = useParams();

  const [response, call, loading] = useAxios({
    ...__getPortoutLog(portout_id),
  });

  useEffect(() => {
    if (response && response.status) {
      setPortoutHistory(response.data);
    }
  }, [response]);

  useEffect(() => {
    call();
  }, []);

  return loading ? (
    <Title content="Please wait..." variant="subtitle2" gutterBottom />
  ) : (
    <>
      <Box mb={2} pt={2}>
        <Typography variant="h5" align="left">
          Portout Log
        </Typography>
      </Box>

      {response && portoutHistory.data ? (
        <>
          <Box
            sx={{ width: "100%", mb: 5 }}
            display="flex"
            alignItems="center"
            flexDirection="column"
          >
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">ID</TableCell>
                    <TableCell align="left">MSISDN</TableCell>
                    <TableCell align="left">Batch ID</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">Port Status</TableCell>
                    <TableCell align="left">Account Number</TableCell>
                    <TableCell align="left">Account Password</TableCell>
                    <TableCell align="left">Effective Date</TableCell>
                    <TableCell align="left">Expiration Date</TableCell>
                    <TableCell align="left">Created At</TableCell>
                    <TableCell align="left">Last Updated</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="left">
                      {portoutHistory.data.id}
                    </TableCell>
                    <TableCell align="left">
                      {portoutHistory.data.msisdn}
                    </TableCell>
                    <TableCell align="left">
                      <Link
                        underline="none"
                        to={`/it/portout/batch/${portoutHistory.data.batch_id}`}
                      >
                        {portoutHistory.data.batch_id}
                      </Link>
                    </TableCell>
                    <TableCell align="left">
                      <Chip
                        label={portoutHistory.data.status}
                        size="small"
                        color={getChipColor(portoutHistory.data.status)}
                      />
                    </TableCell>
                    <TableCell align="left">
                      <Chip
                        label={portoutHistory.data.port_status || "N/A"}
                        size="small"
                        color={getChipColor(portoutHistory.data.port_status)}
                      />
                    </TableCell>
                    <TableCell align="left">
                      {portoutHistory.data.account_number}
                    </TableCell>
                    <TableCell align="left">
                      {portoutHistory.data.account_password}
                    </TableCell>
                    <TableCell align="left">
                      {portoutHistory.data.effective_date &&
                        `${format(
                          new Date(portoutHistory.data.effective_date),
                          "MMMM d, y hh:mm a"
                        )}`}
                    </TableCell>
                    <TableCell align="left">
                      {portoutHistory.data.expiration_date &&
                        `${format(
                          new Date(portoutHistory.data.expiration_date),
                          "MMMM d, y hh:mm a"
                        )}`}
                    </TableCell>
                    <TableCell align="left">
                      {portoutHistory.data.created_at &&
                        `${format(
                          new Date(portoutHistory.data.created_at),
                          "MMMM d, y hh:mm a"
                        )}`}
                    </TableCell>
                    <TableCell align="left">
                      {portoutHistory.data.last_updated &&
                        `${format(
                          new Date(portoutHistory.data.last_updated),
                          "MMMM d, y hh:mm a"
                        )}`}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <ApiLogHistory data={portoutHistory.history?.data || []} />
        </>
      ) : (
        <Box mb={2} pt={2}>
          <Typography variant="h5" align="left">
            No Data
          </Typography>
        </Box>
      )}
    </>
  );
};

export default PortoutHistory;

